/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Dev environment overrides.
 *
 * @author Hari Gangadharan
 */

const SSI_CLIENT_ID = 'I3l3CiMiPkq8LpGSK9IMRcHBJlSQKhYH';
const LOCATION_HOST = typeof window !== 'undefined' ? `https://${window.location.host}` : null;
const dev = {
  ENVIRONMENT: 'perf',
  PARTNER_ENV: 'perf',
  GTM_AUTH: 'fBAn5khLdTsxZKxT5nnz0A',
  GTM_PREVIEW: 'env-6',
  CSG_API_BASE_URL: 'https://content-service-perf.stg-prsn.com/csg/api/v3',
  PAPER_API_BASE_URL: 'https://paperapiperf.stg-openclass.com/nextext-api/api/platforms/bookshelf',
  PRISM_API_BASE_URL: 'https://prismperf.stg-prsn.com/api',
  SPECTRUM_API_BASE_URL: 'https://spectrum-ppe.pearsoned.com/api',
  SPECTRUM_API_V4_BASE_URL: 'https://spectrum-ppe.pearsoned.com/api/v4',
  STPAPER_API_BASE_URL: 'https://stpaperapiprf.stg-prsn.com/etext/v2',
  MARIN_API_BASE_URL: 'https://plus-dev.pearson.com/marin/api/1.0',
  MARIN_API_BASE_URL_V2: 'https://plus-dev.pearson.com/marin/api/2.0',
  MARIN_API_BASE_URL_V3: 'https://plus-dev.pearson.com/marin/api/3.0',
  ETEXT_API_BASE_URL: 'https://etext.pearson.com/api/nextext-api/v1/api', // Need PPE link
  IDC_API_BASE_URL: 'https://etext-instructor.pearson.com/idc-api/', // Need PPE link
  PSEUDO_LOCALE_CODE: null,
  CLIENT_ID: '29s6iaLv3PblrAbzCP9kHlFY5ntGeNN7',
  SSI_CLIENT_ID,
  ZEPPELIN_URL: 'https://product-transaction.openclass.com/products',// Need PPE link
  CONSOLE_URL: 'https://console-ppe.pearson.com',
  TENANT_ID_ETEXT: 'beeea450-02f6-4f88-842e-cec9364453b7',
  TENANT_KEY_ETEXT: '4f0fbc0b-2a5a-4382-90c4-d8ecbba99158',
  TENANT_KEY_ETEXT_PDF: 'bb0a1d97-78af-44e4-bfe4-810c535a45c0',
  SPECTRUM_X_TENANTKEY: '297a5917-24fa-43fe-a27b-426126bd7cf4',
  NEWRELIC_CONFIG_NAME: '/newrelic/newrelic.js',
  NEWRELIC_ENABLED: false,
  NEWRELIC_CONFIG: {
    accountId: 1322480,
    agentId: 274529857,
    applicationId: 91909111,
    licenseKey: 'd527718953',
    trustKey: 691807
  },
  ALGOLIA_SEARCH_CONFIG: {
    appId: 'XFOI9EBBHR',
    apiKey: 'f52b6c3d41be7aad7b87f76a0259213d',
    productIndex: 'ppe-mojo-product-index',
    categoryIndex: 'ppe-mojo-category-index',
    accountUrl: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/account',
    changePassword: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/account/change-password',
    helpCenter: 'https://pearson-perf.pearson.com/en-us/pearsonplus/support.html',
    searchQuery: 'https://pearson-perf.pearson.com/en-us/pearsonplus/search.html?utm_source=authhome&utm_medium=webapp&utm_campaign=search&utm_content=searchbar&aq=',
    preferencesCenter: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/account/preferences',
    resetPassword: `https://login-ppe.pearson.com/v1/piapi-int/iesui/forgot-unpw?client_id=${SSI_CLIENT_ID}&login_success_url=${LOCATION_HOST}/home`
  },
  ADD_A_TITLE_URL: {
    HERO: 'https://pearson-perf.pearson.com/en-us/pearsonplus/search.html?utm_source=authhome&utm_medium=webapp&utm_campaign=add_title_hero',
    LIBRARY: 'https://pearson-perf.pearson.com/en-us/pearsonplus/search.html?utm_source=authhome&utm_medium=webapp&utm_campaign=add_title_library&utm_content=addatitle&aq='
  },
  BOOKSHELF_CONFIG: {
    checkout: 'https://pearson-perf.pearson.com/en-us/pearsonplus/pricing.html?utm_source=authhome&utm_medium=display&utm_campaign=XXLEGP0721PLUS&utm_content=',
    addAnother: 'https://pearson-perf.pearson.com/en-us/pearsonplus/search.html?utm_source=authhome&utm_medium=display&utm_campaign=XXLEGP0721PLUS&utm_content=',
    pmcHeader: 'https://pearson-perf.pearson.com/en-us/pearsonplus.nav-content.standalone.html',
    pmcSearch: 'https://pearson-perf.pearson.com',
    purchase: 'https://pearson-perf.pearson.com/en-us/pearsonplus/search.html',
    logo: 'https://pearson-perf.pearson.com/en-us/pearsonplus/pricing.html?utm_source=authhome&utm_medium=webapp&utm_campaign=logo&utm_content=logo',
    updatePayment: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/account/payment-methods',
    faq: 'https://pearson-perf.pearson.com/en-us/pearsonplus/support/etext-app.html',
    changePassword: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/account/change-password',
    updateProfile: 'https://pearson-perf.pearson.com/store/en-us/pearsonplus/my-account/update-profile',
    chatbot: {
      url: 'https://pearson.my.salesforce.com/embeddedservice/5.0/esw.min.js',
      baseUrl: 'https://pearson.my.salesforce.com',
      supportUrl: 'https://support.pearson.com/getsupport',
      id: '00Db0000000e0e2',
      name: 'NAUS_HETS_DTC_CS_Bot',
      baseLiveAgentContentURL: 'https://c.la3-c1-fra.salesforceliveagent.com/content',
      deploymentId: '572b0000000ClKC',
      buttonId: '5735p000000sXvm',
      baseLiveAgentURL: 'https://d.la3-c1-fra.salesforceliveagent.com/chat',
      eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I5p000000sXuZEAU_17a41f20db5',
      isOfflineSupportEnabled: false,
      authCode: '00D9V00000AwXsH',
      authKey: 'Pearson_Virtual_Assistant_Authenticated',
      authURL: 'https://pearson--testbau25.sandbox.my.site.com/ESWPearsonVirtualAssist1744019208719',
      scrt2URL: 'https://pearson--testbau25.sandbox.my.salesforce-scrt.com',
      eswUrl: 'https://pearson--testbau25.sandbox.my.site.com/ESWPearsonVirtualAssist1744019208719/assets/js/bootstrap.min.js',
      generateTokenUrl: 'https://pearson-stg2.pearson.com/services/pearson/generatejwt'
    },
    more: {
      MOJO_TERMS: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/terms-of-use.html',
      MOJO_PRIVACY: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/user-privacy-policy.html',
      MOJO_COOKIES: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/cookie-policy.html',
      MOJO_INFO: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/cookie-policy.html',
      MOJO_ACCESSIBILITY: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/accessibility.html',
      MOJO_NOTICE: 'https://pearson-perf.pearson.com/en-us/pearsonplus/legal/patent-notice.html',
      MOJO_PEARSON_ACCESSIBILITY: 'https://pearson-perf.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
      MOJO_SUPPORT: 'https://pearson-perf.pearson.com/en-us/pearsonplus/support.html',
      MOJO_APP: 'https://pearson-perf.pearson.com/en-us/pearsonplus/mobile-app.html',
      COMMUNITY_GUIDELINES: 'https://pearson-perf.pearson.com-ppe.pearson.com/en-us/pearsonplus/community-guidelines.html'
    }
  },
  PRODUCT_TOKEN: '80153',
  PLUS_URL: 'https://plus-ppe.pearson.com',
  ETEXT_URL: 'https://etext-ise-ppe.pearson.com',
  IES_BASE_URL: 'https://login-ppe.pearson.com/v1/piapi-pqa',
  HELP_CENTER_NON_MOJO: 'https://pearson--testbau.sandbox.my.site.com/getsupport/s/',
  CHANNELS_MAPPING_URL: 'https://api.studychannel-ppe.pearsondev.tech/v1',
  CHANNELS_STATIC_URL: 'https://static.studychannel-ppe.pearsondev.tech/v1',
  CHANNELS_MAPPING_URL_TIMEOUT: 10000,
  STUDY_CHANNEL_URL: 'https://pearson-perf.pearson.com/channels'
};

module.exports = dev;
